<template>
    <div class="modal fade" id="productFormModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-simple">
            <div class="modal-content">
                <div class="modal-body">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    <div class="text-center mb-4">
                        <h4 class="mb-2">{{ isEdit ? 'تعديل البيانات الأساسية' : 'إضافة منتج' }}</h4>
                        <p class="text-muted mb-0">كل منتج تجاري يجب أن يرتبط بصنف نمطي معتمد؛ التصنيف يُستمد من الصنف النمطي.</p>
                    </div>

                    <el-form label-position="top" :model="form" :rules="rules" ref="formRef">
                        <div class="row g-3">
                            <div class="col-12">
                                <el-form-item prop="NationalFormularyItemsId" label="الصنف النمطي (معتمد)">
                                    <el-select v-model="form.NationalFormularyItemsId"
                                               filterable
                                               remote
                                               reserve-keyword
                                               clearable
                                               style="width:100%"
                                               :loading="formularyRemoteLoading"
                                               :remote-method="remoteSearchNationalFormulary"
                                               placeholder="ابحث بالاسم العلمي أو الكود الوطني أو التصنيف">
                                        <el-option v-for="item in mergedFormularyItems"
                                                   :key="item.id"
                                                   :label="formularyLabel(item)"
                                                   :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>

                            <div class="col-12" v-if="selectedFormularyPreview">
                                <div class="p-3 rounded border bg-label-secondary bg-opacity-10 small">
                                    <div class="text-muted mb-1">بيانات الصنف النمطي (للاطلاع)</div>
                                    <div><span class="text-muted">الكود الوطني:</span> <code>{{ selectedFormularyPreview.nationalCode || '—' }}</code></div>
                                    <div><span class="text-muted">الاسم العلمي:</span> {{ selectedFormularyPreview.scientificName || '—' }}</div>
                                    <div><span class="text-muted">التصنيف:</span> {{ selectedFormularyPreview.categoryName || '—' }}</div>
                                    <div><span class="text-muted">CLASSIFECTION:</span> {{ selectedFormularyPreview.classifection || '—' }}</div>
                                    <div><span class="text-muted">PRIORITY:</span> {{ selectedFormularyPreview.proiority || '—' }}</div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <el-form-item prop="ProductName" label="الاسم التجاري">
                                    <input class="form-control" v-model="form.ProductName" placeholder="الاسم التجاري للمنتج">
                                </el-form-item>
                            </div>

                            <div class="col-md-6">
                                <el-form-item label="رقم التشغيلة (BatchNumber)">
                                    <input class="form-control" v-model="form.BatchNumber" placeholder="اختياري">
                                </el-form-item>
                            </div>

                            <div class="col-md-6">
                                <el-form-item label="الشركة المصنعة">
                                    <el-select v-model="form.ManufacturerId" filterable clearable style="width:100%" placeholder="اختياري">
                                        <el-option v-for="item in manufacturers" :key="item.id"
                                                   :label="item.name" :value="item.id"
                                                   :disabled="item.isSelectable === false">
                                            <span>{{ item.name }}</span>
                                            <small v-if="item.isSelectable === false" class="text-danger ms-2">
                                                {{ item.blockReason }}
                                            </small>
                                            <small v-else-if="item.isExpiringSoon" class="text-warning ms-2">
                                                رخصة تنتهي قريباً
                                            </small>
                                        </el-option>
                                    </el-select>
                                    <small class="text-muted d-block mt-1">
                                        الشركات المرخّصة من إدارة الصيدلة فقط.
                                        <span v-if="currentManufacturerBlocked" class="text-danger">
                                            شركة هذا المنتج لم تعد مرخّصة — اخترْ بديلاً مرخّصاً قبل الحفظ.
                                        </span>
                                    </small>
                                </el-form-item>
                            </div>

                            <div class="col-md-6">
                                <el-form-item label="بلد المنشأ">
                                    <el-select v-model="form.CountryRegionId" filterable clearable style="width:100%" placeholder="اختياري">
                                        <el-option v-for="item in countries" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>

                            <div class="col-md-6">
                                <el-form-item label="وحدة الصرف الأساسية">
                                    <el-select v-model="form.BaseUnitMeasureId" filterable clearable style="width:100%" placeholder="اختياري">
                                        <el-option v-for="item in unitMeasures" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                    <small class="text-muted d-block">
                                        الوحدة التي يُصرف بها الصنف فعلياً (حبة، مليلتر). كل الأرصدة تُحسب بها،
                                        ومنها تُبنى وحدات التعبئة عند الصرف. لا يمكن تغييرها بعد وجود رصيد للصنف.
                                    </small>
                                </el-form-item>
                            </div>

                            <div class="col-12">
                                <el-form-item label="الوصف">
                                    <textarea class="form-control" rows="3" v-model="form.Descriptions" placeholder="وصف اختياري"></textarea>
                                </el-form-item>
                            </div>

                            <div class="col-md-6">
                                <el-form-item label="صورة المنتج">
                                    <input type="file" class="form-control" accept="image/*" @change="selectImage($event)">
                                    <small class="text-muted d-block mt-1" v-if="form.ImageName">{{ form.ImageName }}</small>
                                </el-form-item>
                            </div>

                            <div class="col-md-6">
                                <el-form-item label="عرض للعموم">
                                    <div class="form-check form-switch mt-2">
                                        <input id="productPublicSwitch" class="form-check-input" type="checkbox" v-model="form.ShowOnPublicFormulary">
                                        <label class="form-check-label" for="productPublicSwitch">إظهار في القائمة العامة</label>
                                    </div>
                                </el-form-item>
                            </div>

                            <div class="col-12 text-center mt-2">
                                <button type="button" class="btn btn-primary me-2" @click.prevent="submit()">حفظ</button>
                                <button type="button" class="btn btn-label-secondary" data-bs-dismiss="modal">إلغاء</button>
                            </div>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductFormModal',
    props: {
        manufacturers: { type: Array, default: () => [] },
        countries: { type: Array, default: () => [] },
        unitMeasures: { type: Array, default: () => [] },
        formularyItems: { type: Array, default: () => [] }
    },
    data() {
        return {
            isEdit: false,
            editFormularyExtra: [],
            internalFormularyOptions: [],
            formularyRemoteLoading: false,
            formularySearchTimer: null,
            form: this.emptyForm(),
            rules: {
                ProductName: this.$helper.Required(),
                NationalFormularyItemsId: this.$helper.Required()
            }
        };
    },
    computed: {
        /** شركة المنتج المفتوح سقط ترخيصها — تنبيه ظاهر بدل رفض صامت عند الحفظ. */
        currentManufacturerBlocked() {
            const id = Number(this.form.ManufacturerId || 0);
            if (!id) return false;
            const found = (this.manufacturers || []).find((m) => Number(m.id) === id);
            return !!(found && found.isSelectable === false);
        },

        mergedFormularyItems() {
            const map = new Map();
            (this.internalFormularyOptions || []).forEach((x) => {
                if (x && x.id != null) map.set(Number(x.id), x);
            });
            (this.editFormularyExtra || []).forEach((x) => {
                if (x && x.id != null) map.set(Number(x.id), x);
            });
            return Array.from(map.values());
        },
        selectedFormularyPreview() {
            const id = this.form.NationalFormularyItemsId;
            if (!id) return null;
            const n = Number(id);
            return this.mergedFormularyItems.find(x => Number(x.id) === n) || null;
        }
    },
    beforeDestroy() {
        if (this.formularySearchTimer) {
            clearTimeout(this.formularySearchTimer);
        }
    },
    methods: {
        emptyForm() {
            return {
                Id: 0,
                ProductName: '',
                NationalFormularyItemsId: '',
                ManufacturerId: '',
                CountryRegionId: '',
                BaseUnitMeasureId: '',
                BatchNumber: '',
                Descriptions: '',
                Image: '',
                ImageName: '',
                ShowOnPublicFormulary: true
            };
        },
        normalizeNationalFormularyList(data) {
            const root = data || {};
            const raw = root.info != null ? root.info : root.Info;
            const arr = Array.isArray(raw) ? raw : [];
            return arr.map((r) => ({
                id: r.id != null ? r.id : r.Id,
                nationalCode: r.nationalCode != null ? r.nationalCode : (r.NationalCode || ''),
                scientificName: r.scientificName != null ? r.scientificName : (r.ScientificName || ''),
                categoryName: r.categoryName != null ? r.categoryName : (r.CategoryName || null),
                classifection: r.classifection != null ? r.classifection : (r.Classifection || ''),
                proiority: r.proiority != null ? r.proiority : (r.Proiority || ''),
            })).filter((x) => x.id != null);
        },
        async loadFormularyFromApi(search = '') {
            this.formularyRemoteLoading = true;
            try {
                const res = await this.$http.GetNationalFormularyApproved(search, 500);
                this.internalFormularyOptions = this.normalizeNationalFormularyList(res.data);
            } catch {
                this.internalFormularyOptions = [];
            } finally {
                this.formularyRemoteLoading = false;
            }
        },
        remoteSearchNationalFormulary(query) {
            if (this.formularySearchTimer) {
                clearTimeout(this.formularySearchTimer);
            }
            const q = String(query || '').trim();
            this.formularySearchTimer = setTimeout(() => {
                this.loadFormularyFromApi(q);
            }, 280);
        },
        formularyLabel(item) {
            const code = item.nationalCode || item.NationalCode || '';
            const name = item.scientificName || item.name || item.Name || '';
            return code ? `${name} (${code})` : name;
        },
        open(product) {
            this.isEdit = !!product;
            this.editFormularyExtra = [];
            this.form = this.emptyForm();
            this.internalFormularyOptions = this.normalizeNationalFormularyList({ info: this.formularyItems || [] });
            this.loadFormularyFromApi('');
            if (product) {
                const fid = product.nationalFormularyItemId || product.nationalFormularyItemsId;
                if (fid) {
                    this.editFormularyExtra = [{
                        id: Number(fid),
                        nationalCode: product.nationalCode || '',
                        scientificName: product.nationalFormularyName || product.scientificName || '',
                        categoryName: product.categories || product.categoryName || null
                    }];
                }
                this.form = {
                    Id: product.id,
                    ProductName: product.productName || product.name || '',
                    NationalFormularyItemsId: fid || '',
                    ManufacturerId: product.manufacturerId || '',
                    CountryRegionId: product.countryRegionId || '',
                    BaseUnitMeasureId: product.baseUnitMeasureId || '',
                    BatchNumber: product.batchNumber || '',
                    Descriptions: product.descriptions || '',
                    Image: '',
                    ImageName: '',
                    ShowOnPublicFormulary: !!product.showOnPublicFormulary
                };
            }
            this.$nextTick(() => {
                if (this.$refs.formRef) this.$refs.formRef.clearValidate();
                const el = document.getElementById('productFormModal');
                if (el && window.bootstrap) window.bootstrap.Modal.getOrCreateInstance(el).show();
            });
        },
        close() {
            const el = document.getElementById('productFormModal');
            if (el && window.bootstrap) window.bootstrap.Modal.getOrCreateInstance(el).hide();
        },
        selectImage(event) {
            const file = event.target.files && event.target.files[0];
            if (!file) return;
            if (!file.type || !file.type.startsWith('image')) {
                this.$helper.ShowMessage('error', 'خطأ', 'الرجاء اختيار ملف صورة صالح');
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                this.form.ImageName = file.name;
                this.form.Image = reader.result;
            };
            reader.readAsDataURL(file);
        },
        submit() {
            this.$refs.formRef.validate(valid => {
                if (!valid) {
                    this.$helper.showSwal('warning');
                    return;
                }

                const payload = {
                    Id: Number(this.form.Id || 0),
                    NationalFormularyItemsId: Number(this.form.NationalFormularyItemsId || 0),
                    ProductName: (this.form.ProductName || '').trim(),
                    ManufacturerId: this.form.ManufacturerId === '' ? null : Number(this.form.ManufacturerId),
                    CountryRegionId: this.form.CountryRegionId === '' ? null : Number(this.form.CountryRegionId),
                    BaseUnitMeasureId: this.form.BaseUnitMeasureId === '' || this.form.BaseUnitMeasureId == null
                        ? null
                        : Number(this.form.BaseUnitMeasureId),
                    BatchNumber: this.form.BatchNumber || null,
                    Descriptions: this.form.Descriptions || null,
                    Image: this.form.Image || null,
                    ImageName: this.form.ImageName || null,
                    ShowOnPublicFormulary: !!this.form.ShowOnPublicFormulary
                };

                this.$blockUI.Start();
                const request = this.isEdit ? this.$http.EditProducts(payload) : this.$http.AddProducts(payload);
                request.then(response => {
                    this.$blockUI.Stop();
                    this.close();
                    this.$emit('saved', response.data);
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                }).catch(err => {
                    this.$blockUI.Stop();
                    const message = err && err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع';
                    this.$helper.ShowMessage('error', 'خطأ بالعملية', message);
                });
            });
        }
    }
};
</script>
